import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'
import LoginModal from 'desktop/containers/modals/login_modal'
import { currencyAware } from 'base/components/currency_aware'
import SiteLocation from 'base/constants/site_location'
import EmailCheckForm from 'base/components/forms/email_check_form'
import Hub from 'base/hub'
import Event from 'base/event'
import BuilderComponent from 'base/components/pages/builder/component'

class FooterReferralSection extends Component {
  state = {
    showLoginModal: false,
    isNewUser: false,
    email: '',
  }

  handleShowLoginModal = () => {
    this.setState({ showLoginModal: true })
  }

  handleLoginSuccess = () => {
    this.setState({ showLoginModal: false })
  }

  handleEmailChecked = ({ isNewUser, email }) => {
    this.setState({ showLoginModal: true, isNewUser: isNewUser, email: email })

    if (isNewUser) {
      Hub.pub(Event.Login.SHOW_SIGN_UP_VIEW, {
        site_location: SiteLocation.RIGHT_FOOTER,
      })
    } else {
      Hub.pub(Event.Login.SHOW_SIGN_IN_VIEW, {
        site_location: SiteLocation.RIGHT_FOOTER,
      })
    }
  }

  render() {
    return (
      <div
        className={classNames({
          'refer-module': this.props.isSignedIn,
          'signup-module': !this.props.isSignedIn,
        })}
      >
        {this.state.showLoginModal && (
          <LoginModal
            onRequestClose={() => this.setState({ showLoginModal: false })}
            skipEmailEntry={true}
            isNewUser={this.state.isNewUser}
            email={this.state.email}
            onSignInSuccess={this.handleLoginSuccess}
            onSignUpSuccess={this.handleLoginSuccess}
            siteLocation={SiteLocation.RIGHT_FOOTER}
          />
        )}

        <BuilderComponent model="footer-copy" />

        {this.props.isSignedIn && this.props.currencyIsUSD && (
          <div id="footer-referral">
            <form>
              <input
                type="text"
                value={this.props.referralUrl}
                autoComplete="off"
                title="copy me"
                className="footer__invite-token"
                size="44"
                onClick={event => event.target.select()}
                aria-labelledby="footer-referral"
                readOnly
              />
            </form>
          </div>
        )}

        {!this.props.isSignedIn && (
          <EmailCheckForm
            onEmailChecked={this.handleEmailChecked}
            siteLocation={SiteLocation.RIGHT_FOOTER}
            hideLoader={true}
          />
        )}
      </div>
    )
  }
}

FooterReferralSection.propTypes = {
  isSignedIn: PropTypes.bool.isRequired,
  referralUrl: PropTypes.string,
}

FooterReferralSection.defaultProps = {
  referralUrl: '',
}

export default currencyAware(FooterReferralSection)
